export const fetchIcon = async (badgeIcon, httpClient) => {
    try {
        const fetchIconResponse = await httpClient.get(badgeIcon);
        const hasLoadFailed = fetchIconResponse.status !== 200;
        const iconContent = hasLoadFailed ? '' : fetchIconResponse.data;
        return { hasLoadFailed, iconContent };
    }
    catch (_a) {
        return { hasLoadFailed: true, iconContent: '' };
    }
};
//# sourceMappingURL=icon.js.map